import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { attr, hasMany, belongsTo } from '@ember-data/model';
import ShModel from './sh-model';

const AssignmentSummary = ShModel.extend({
  watcherCount: attr('number'),
  isRead: attr('boolean'),
  createdAt: attr('date'),
  createdByUserName: attr('string'),
  declinedCount: attr('number'),
  declinedUsers: attr('user-results'),
  hiredCount: attr('number'),
  hiredUsers: attr('user-results'),
  isAwaitingDirectOffer: attr('boolean'),
  isNeedsAction: attr('boolean'),
  lastActivity: attr('date'),
  pendingCount: attr('number'),
  pendingUsers: attr('user-results'),
  publishedAt: attr('date'),
  slug: attr('string'),
  select: attr('boolean'),
  status: attr('string'),
  title: attr('string'),
  updatedAt: attr('date'),
  isUrgent: attr('boolean'),
  type: attr('number'),

  /**
   * Relationships
   */
  applications: hasMany('application', { async: false }),
  companyTeam: belongsTo('companyTeam', { async: false }),
  preAssignment: belongsTo('preAssignment', { async: false }),

  // Computed Properties

  /**
   * In almost all cases you should be using this title to display to the user.
   *
   * @type {String}     Title taking into account the urgent flag.
   */
  titleWithUrgent: computed('title', 'isUrgent', function() {
    if (this.get('isUrgent')) {
      return `[Urgent] ${this.get('title')}`;
    }

    return this.get('title');
  }),

  /**
  * @deprecated Use slug for URL and id for API calls
  */
  idWithSlug: readOnly('slug'),
});

export default AssignmentSummary;
